import ActualPackStatus, { type Status } from '~/Api/Analytics/VirtualBrand/ActualPackStatus';
import Country from '~/Api/Country/Country';
import mapDataSource, { RawDataSource } from '~/Api/DataSource/mapDataSource';
import ProductPrice from '~/Api/Product/ProductPrice';
import Price from '~/utils/Price/Price';

import PriceTime from './PriceTime';

export interface RawPriceTime {
	days: number;
	since: string;
	dataSource: RawDataSource | null;
	price: { type: string; value: string; currency: string } | null;
	status: { value: Status; reasonFields: { [key in string]: string } };
}

export default function mapPriceTime(time: RawPriceTime, country: Country): PriceTime {
	return new PriceTime(
		time.days,
		new Date(time.since),
		time.dataSource ? mapDataSource({ ...time.dataSource, country }) : null,
		time.price !== null ? new ProductPrice(time.price.type, new Price(time.price.value, time.price.currency), 0) : null,
		new ActualPackStatus(time.status.value, time.status.reasonFields)
	);
}
